import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import '../../Roles/roles.css';
import { Pagination } from '../../../../components/common/Pagination';
import { ROUTES } from '../../../../constants/routes';
import { EmptyState } from '../../../../components/common/EmptyState/EmptyState';
import { ListContent } from '../../components/ListPageLayout';
import { OrganizationStationsTable } from './OrganizationStationsTable';
import { OrganizationStationsTableSkeleton } from './OrganizationStationsTableSkeleton';
import { AttachStationDialog } from './AttachStationDialog';
import { DetachStationDialog } from './DetachStationDialog';
import { useOrganizationStationsPage } from './hooks/useOrganizationStationsPage';

export const OrganizationStations = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const page = useOrganizationStationsPage();

  return (
    <div className="desktop-layout">
      <div className="content-inner" style={{ padding: '2.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <button
              type="button"
              className="back-link"
              onClick={() => navigate(`/${ROUTES.DASHBOARD}/${ROUTES.DASH_ORGANIZATIONS}`)}
            >
              <span className="material-symbols-outlined" aria-hidden="true">arrow_back</span>
              {t('dashboard.organizationStations.back')}
            </button>
            <h1 style={{ margin: 0, fontSize: '1.25rem' }}>
              {page.organizationName || t('dashboard.organizationStations.title')}
            </h1>
          </div>
          <button type="button" className="primary-action-btn" onClick={page.openAttach}>
            <span className="material-symbols-outlined" aria-hidden="true">add</span>
            {t('dashboard.organizationStations.addStation')}
          </button>
        </div>

        <ListContent
          hasError={Boolean(page.error)}
          errorMessage={t('dashboard.organizationStations.errorLoading')}
          onRetry={() => void page.refetch()}
          isLoading={page.isLoading}
          skeleton={<OrganizationStationsTableSkeleton />}
        >
          {page.stations.length === 0 ? (
            <EmptyState
              icon="ev_station"
              message={t('dashboard.organizationStations.empty')}
            />
          ) : (
            <>
              <OrganizationStationsTable
                stations={page.stations}
                onDetach={page.requestDetach}
              />
              <Pagination
                total={page.total}
                page={page.pageIndex}
                rowsPerPage={page.rowsPerPage}
                onPageChange={page.handlePageChange}
                onRowsPerPageChange={page.handleRowsPerPageChange}
              />
            </>
          )}
        </ListContent>
      </div>

      <AttachStationDialog
        open={page.isAttachOpen}
        organizationId={page.organizationId}
        onClose={page.closeAttach}
        onAttach={page.attachStation}
        isSubmitting={page.isSaving}
        errorMessage={page.attachError}
      />
      <DetachStationDialog
        station={page.stationToDetach}
        organizationName={page.organizationName}
        onClose={page.cancelDetach}
        onConfirm={page.confirmDetach}
        isSubmitting={page.isSaving}
        errorMessage={page.detachError}
      />
    </div>
  );
};

export default OrganizationStations;
